/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>分类统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
          v-model="date"
          type="month"
          placeholder="选择日期"
          :picker-options="pickerOptions"
          @change="selectListTime"
        >
        </el-date-picker>
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table :data="listData" style="width: 100%">
      <el-table-column type="expand">

        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item v-for="item in props.row[Object.keys(props.row)[0]]" :label="item.name" >
              <span>{{ item.totalMoney }}元</span>
<!--              <span>{{ index+1 }}</span>-->
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="日期" prop="id"> </el-table-column>
      <el-table-column label="烟酒饮料" prop="cigarette"> </el-table-column>
      <el-table-column label="非香烟" prop="nonCigarette"> </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
  </div>
</template>

<script>
import { Store } from "vuex";
import { OrderList, OrderRefund, OrderDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import { getOrder, getSalesTime, getSalesClassify } from "@/api/api.js";
import { Empty } from "element-ui";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "预览",
      date: "",
      year: "",
      month: "",
      day: "",
      orderStatus: "", //订单类型
      orderList: "", //订单列表
      selectTime: [], //选择的时间

      pickerOptions: {
        format: "yyyy-MM", // 设置日期格式为年-月
      },
      editForm: {
        id: "",
        name: "",
        payType: 1,
        partner: "",
        subMchId: "",
        appid: "",
        notifyUrl: "",
        signType: "",
        partnerKey: "",
        sellerUserId: "",
        certPath: "",
        certPassword: "",
        rsaKey: "",
        token: localStorage.getItem("logintoken"),
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //展示的数据

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    let date = new Date();
    //把当前时间减10天，赋值到开始时间

    this.selectTime = date;
    this.getData(date);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取订单数据
    getData(date) {
      this.loading = true;
      let selectDate = new Date(date);
      this.date =
        selectDate.getFullYear() +
        "-" +
        ("0" + (selectDate.getMonth() + 1)).slice(-2);
      getSalesClassify({
        storeId: localStorage.getItem("storeId"),
        Month: this.date,
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.listData = res.data;
          //把listData的每个元素加上index属性
          this.listData.forEach((item, index) => {
            item.id = index + 1 + "号";
          });
          //如果listData里面每个元素加上cigarette和nonCigarette属性
            this.listData.forEach((item3, index) => {
                console.log(index,item3[index+1],'99999')
                // 每个item也是一个数组，把数组里面name属性值为香烟的元素的price属性值赋值到item.cigarette
                // 把数组里面name属性值为非香烟的元素的price属性值赋值到item.nonCigarette
                console.log( item3[index+1].filter((item2) => item2.name == "非香烟")[0].totalMoney,'!!!!')
                item3.nonCigarette = item3[index+1].filter((item2) => item2.name == "非香烟")[0].totalMoney;
                item3.cigarette = item3[index+1].filter((item2) => item2.name == "烟酒饮料")[0]?item3[index+1].filter((item2) => item2.name == "烟酒饮料")[0].totalMoney:0;

            });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 选择时间
    selectListTime(date) {
      this.getData(date);
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.button-date {
  margin: 15px 0;
}
.demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>







// WEBPACK FOOTER //
// src/views/pay/classifyFilter.vue